import _styled from "@emotion/styled/base";

/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import { inputControl } from '../../utils/input';
export const StyledTextarea = _styled("textarea", process.env.NODE_ENV === "production" ? {
  target: "ebk7yr50"
} : {
  target: "ebk7yr50",
  label: "StyledTextarea"
})("width:100%;", inputControl, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkB3b3JkcHJlc3MvY29tcG9uZW50cy9zcmMvdGV4dGFyZWEtY29udHJvbC9zdHlsZXMvdGV4dGFyZWEtY29udHJvbC1zdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVTZDIiwiZmlsZSI6IkB3b3JkcHJlc3MvY29tcG9uZW50cy9zcmMvdGV4dGFyZWEtY29udHJvbC9zdHlsZXMvdGV4dGFyZWEtY29udHJvbC1zdHlsZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEV4dGVybmFsIGRlcGVuZGVuY2llc1xuICovXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbi8qKlxuICogSW50ZXJuYWwgZGVwZW5kZW5jaWVzXG4gKi9cbmltcG9ydCB7IGlucHV0Q29udHJvbCB9IGZyb20gJy4uLy4uL3V0aWxzL2lucHV0JztcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRleHRhcmVhID0gc3R5bGVkLnRleHRhcmVhYFxuXHR3aWR0aDogMTAwJTtcblx0JHsgaW5wdXRDb250cm9sIH1cbmA7XG4iXX0= */"));
//# sourceMappingURL=textarea-control-styles.js.map